/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-27 10:09:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-18 15:21:20
 * @FilePath: /src/app/not-found.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { fetchProductList } from '@/api/product';
import { ListProduct } from '@/api/types/public';
import Button from '@/components/Button';
import RecommendList from '@/components/GuessYouLike';
import Image from '@/components/Image';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { useStore } from '@/providers/app-store-provider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { setSession } from '@/utils/tools';
import { Box, useMediaQuery } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useContext, useEffect, useState } from 'react';

export default function NotFound() {
  const [list, setList] = useState<ListProduct[]>([]);
  const currency = useStore((state) => state.currency);
  const isMobile = useMediaQuery('(max-width:1024px)');
  const { deviceType } = useContext(ResponsiveContext);
  const isWeb = deviceType === EPlatform.WEB;
  const t = useTranslations('notFound');
  const router = useRouter();

  useEffect(() => {
    fetchProductList({
      currency: currency.name,
      group_id: 116,
      limit: 10,
      page: 1,
      in_stock: 1,
      is_sale: 1,
    }).then((res) => setList((res.data as any).list));
  }, [currency]);

  // 每次进入页面时滚动到顶部
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  // TODO: 后续整站重构完，这里就不需要自定义跳转了
  const handleHomeNavigation = (e: React.MouseEvent) => {
    e.preventDefault();
    router.push('/');
  };

  return (
    <div className="bg-[#f5f5f5] min-h-screen">
      {/* Top Banner Section - 对应 .top-img */}
      <div className="relative">
        <Image
          src="/errorBanner.png"
          alt={t('bannerImageAlt')}
          width={1920}
          height={400}
          className="w-full h-auto hidden md:block"
        />
        <Image
          src="/wapErrorBanner.png"
          alt={t('bannerImageAlt')}
          width={750}
          height={420}
          className="w-full h-auto block md:hidden"
        />
        {/* 对应 .words */}
        <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
          {/* 对应 p:nth-child(1) */}
          <p className="text-[36px] lg:text-[72px] text-[#14c7ff] font-bb">404</p>
          {/* 对应 p:nth-child(2) */}
          <p className="text-[15px] lg:text-[36px] text-primary-purple font-bb mt-[0px] lg:mt-[20px] mb-[20px] lg:mb-[30px]">
            {t('title')}
          </p>
          {/* 对应 .el-button */}
          <Link prefetch={false} href="/" onClick={handleHomeNavigation}>
            <Button
              variant="contained"
              color="primary"
              className="h-[25px] lg:h-[60px]  text-white"
              sx={{
                fontSize: isMobile ? '12px' : '20px',
                fontFamily: 'var(--font-bricolage-bold)',
                borderRadius: isMobile ? '5px' : '10px',
              }}
            >
              {t('button')}
            </Button>
          </Link>
        </div>
      </div>

      {/* You May Also Like Section - 对应 .bottom-list */}
      <Box
        className={`py-[22px] lg:py-[70px] text-center bg-[#f5f5f5] ${isWeb ? 'px-[12px] lg:px-[95px]' : ''}`}
      >
        <RecommendList
          list={list}
          renderTitle={(title) => (
            <p className="mb-[16px] lg:mb-[35px] text-[14px] lg:text-[36px] font-bb">{title}</p>
          )}
          onMktClick={() => {
            setSession('zl_goodsDetailEnterPageScene', '404页面猜你喜欢坑位');
          }}
        />
      </Box>
    </div>
  );
}
